export default "__VITE_ASSET__C3NjtB0E__"